import axios from '../config/axiosConfig';

/* Lista device associati all'organizzazione */
export const getDevicesByOrganization = async (orgId) => {
  try {
    const response = await axios.get(`/api/device/organization/${orgId}`);
    return response.data;
  } catch (error) {
    // Gestisci l'errore come preferisci, ad esempio mostrando un messaggio all'utente
    console.error('Error fetching list of devices of current organization', error);
    throw error;
  }
};

/* Lista tipologia device presenti nel db */
export const getModelDevices = async () => {
  try {
    const response = await axios.get('/api/device/devicetype');
    return response.data;
  } catch (error) {
    // Gestisci l'errore come preferisci, ad esempio mostrando un messaggio all'utente
    console.error('Error fetching list of device types', error);
    throw error;
  }
};

/* Recupera i dettagli di un visore */
export const deviceDetails = async (deviceId) => {
  const response = await axios.get(`/api/device/details/${deviceId}`);
  return response.data;
};

/* Modifica le info di un visore */
export const updateDevice = async (deviceId, userData) => {
  try {
    const response = await axios.put(`/api/device/edit/${deviceId}`, { userData });
    return response;
  } catch (error) {
    // Gestisci l'errore come preferisci, ad esempio mostrando un messaggio all'utente
    console.error('Error editing goggle:', error);
    throw error;
  }
};

/* Elimina visore */
export const deleteDevice = async (id) => {
  try {
    const response = await axios.delete(`/api/device/${id}`);
    return response;
  } catch (error) {
    // Gestisci l'errore come preferisci, ad esempio mostrando un messaggio all'utente
    console.error('Error deleting goggle:', error);
    throw error;
  }
};

